import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/challengerConversionSaga";

const CustomDateRange = () => {
  const dispatch = useDispatch();

  const { rangeOptions, selectedRangeOption } = useSelector((state) => state.challengerConversion);

  const onSelectChange = (data) => dispatch(actionCreators.updateCustomRange(data));

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={onSelectChange}
    />
  );
};

export default CustomDateRange;
